import React from 'react'
import PropTypes from 'prop-types'
import { FaExclamationTriangle } from 'react-icons/fa'

import { error, icon } from './DisplayError.module.scss'

const DisplayError = ({ message }) => {
  return (
    <div className={error}>
      <FaExclamationTriangle className={icon} />
      <span>{message}</span>
    </div>
  )
}

DisplayError.propTypes = {
  message: PropTypes.string.isRequired,
}

DisplayError.defaultProps = {}

export default React.memo(DisplayError)
